import FastCashContent from './FastCashContent';

export default FastCashContent;
